import React from "react";
import ImageCard from "./ImageCard";
import DocCard from "./DocCard";
import gettext from "../shared/utils/gettext";
import cropr from "../shared/utils/cropr";

export interface FileOverviewCardsProps {
  attachmentList: any[];
  editable: boolean;
  onClickRemove: (attachmentKey: string) => void;
  destroyable: boolean;
  onClickDestroy: (attachmentKey: string) => void;
}
const FileOverviewCards = (props: FileOverviewCardsProps) => {
  return (
    <div className="img row py-3 overflow-auto">
      {props.attachmentList.map((attachment, i) => (
        <div key={i} className="col-4 col-sm-3 col-md-2 attachment-container py-2">
          <div className="card border-0 attachment-remove">
            {attachment.get("filetype").includes("image") ? (
              <>
                <a data-lightbox="file_overview" href={cropr.getImageUrl(attachment.get("key"))}>
                  <ImageCard imageKey={attachment.get("key")} />
                </a>
                {props.editable && (
                  <button
                    type="button"
                    className="btn btn-light position-absolute"
                    title={gettext("Unlink")}
                    data-image={attachment.get("key")}
                    onClick={() => props.editable && props.onClickRemove(attachment.get("key"))}
                  >
                    <i className="far fa-times" />
                  </button>
                )}
                {props.destroyable && (
                  <button
                    type="button"
                    className="btn btn-light position-absolute"
                    title={gettext("Delete")}
                    data-image={attachment.get("key")}
                    onClick={() => props.onClickDestroy(attachment.get("key"))}
                  >
                    <i className="far fa-trash-alt" />
                  </button>
                )}
              </>
            ) : (
              <>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  className="allowClick"
                  href={`/api/v1/document/get_by_key?key=${attachment.get("key")}&attachment=1`}
                >
                  <DocCard
                    documentKey={attachment.get("key")}
                    documentFileType={attachment.get("filetype")}
                    className="font-size-2"
                  />
                </a>
                {props.editable && (
                  <button
                    type="button"
                    className="btn text-yellow position-absolute"
                    data-image={attachment.get("key")}
                    onClick={() => props.onClickRemove(attachment.get("key"))}
                  >
                    <i className="far fa-times" />
                  </button>
                )}
              </>
            )}
            <ul className="list-group attachment-metadata">
              <li className="list-group-item attachment-row border-0 py-1">
                <div className="text-muted" style={{ fontSize: "0.6rem" }}>
                  {attachment.getCardString()}
                </div>
              </li>
            </ul>
          </div>
        </div>
      ))}
    </div>
  );
};
export default FileOverviewCards;
